import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded border px-2 py-0.5 text-xs font-mono uppercase tracking-label",
  {
    variants: {
      variant: {
        default: "border-border-light bg-bg-card text-text-muted",
        accent: "border-accent/40 bg-accent-dim text-accent",
        success: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
        danger: "border-red-500/30 bg-red-500/10 text-red-300",
        muted: "border-border bg-bg-card text-text-faint",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
